import { Component, inject } from '@angular/core';
import { ToastService } from '../../infrastructure/toast/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  template: `
    @if (toast.current(); as t) {
      <div class="toast" [attr.key]="t.id">{{ t.message }}</div>
    }
  `,
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  readonly toast = inject(ToastService);
}
